import { Shot, ShotVersion } from '../../../types';

type Translate = (key: string, options?: Record<string, unknown>) => string;

interface ShotHeaderProps {
  shot: Shot;
  versions: ShotVersion[];
  collapsed: boolean;
  t: Translate;
  onExpand: () => void;
}

export default function ShotHeader({ shot, versions, collapsed, t, onExpand }: ShotHeaderProps) {
  const completed = versions.filter(version => version.taskStatus === 'completed').length;

  return (
    <div
      className="shot-header-bar"
      style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.7rem 1.25rem', cursor: 'pointer', background: 'color-mix(in srgb, var(--theme-storyboard) 8%, var(--surface))', borderRadius: !collapsed ? 'var(--radius) var(--radius) 0 0' : 'var(--radius)' }}
      onClick={onExpand}
    >
      <strong>#{shot.index}</strong>
      {(shot.directorLabels || []).map((label, labelIndex) => (
        <span
          key={`${labelIndex}:${label}`}
          data-director-label
          title={label}
          style={{
            maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            fontSize: '0.72rem', fontWeight: 600, padding: '2px 7px', borderRadius: '999px',
            background: 'color-mix(in srgb, var(--theme-storyboard) 16%, var(--surface))',
            color: 'var(--theme-storyboard)', flexShrink: 1,
          }}
        >
          {label}
        </span>
      ))}
      {versions.length > 0 && (
        <span style={{ fontSize: '0.85rem', color: completed > 0 ? 'var(--success)' : 'var(--text-2)' }}>
          {completed}/{versions.length}
        </span>
      )}
      <span style={{ flex: 1, minWidth: 0, color: 'var(--text-2)', fontSize: '0.85rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {shot.description || t('shot.noDescription')}
      </span>
      <span style={{ display: 'inline-flex', alignItems: 'center', color: 'var(--text-3)', flexShrink: 0 }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transform: collapsed ? 'none' : 'rotate(180deg)', transition: 'transform 0.2s' }}>
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </span>
    </div>
  );
}
